export default "__VITE_ASSET__BxKP2hUf__"